import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {

    TransactionDetailTurnCoinList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/TransactionDetailTurnCoin/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    TransactionDetailTurnCoinTotal({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/TransactionDetailTurnCoin/Total',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }
}

const mutations = {
    
}

export default {
    state,
    getters,
    actions,
    mutations
}
